import { Box } from '@mui/material';
import {
  DialogContainer,
  DialogTitle,
  DialogBody,
  DialogActions,
  CustomTextArea,
  CustomTextField,
} from '../../../../common/components';

const QualityCommentDialog = ({ open, onClose, editMode, comment, onInputChange, onSave }) => {
  return (
    <DialogContainer open={open} onClose={onClose} size="small">
      <DialogTitle>{editMode ? 'Editar Comentario' : 'Comentario'}</DialogTitle>

      <DialogBody>
        <Box sx={{ display: 'grid', gap: 2 }}>
          <CustomTextField
            label="Tarea"
            name="task_name"
            value={comment?.task_name || ''}
            onChange={onInputChange}
            disabled
          />
          <CustomTextArea
            label="Comentario"
            name="observations"
            value={comment?.observations || ''}
            onChange={onInputChange}
            placeholder="Agregar comentario"
            minRows={4}
          />
        </Box>
      </DialogBody>

      <DialogActions handleClose={onClose} handleSave={onSave} />
    </DialogContainer>
  );
};

export default QualityCommentDialog;
